<template>
  <div>
    <div style="text-align:center;margin-bottom:10px">
      <el-button type="primary" @click="upSubmit" :loading="submiting">开始上传</el-button>
      <el-button type="warning" @click="$refs.upload.clearFiles()">清空列表</el-button>
      <div style="display:flex">
        <el-select v-model="fenlei" placeholder="选择分类" style="margin-top:10px">
          <el-option v-for="fl in fenleis" :key="'fl1-' + fl.Id" :label="fl.Name" :value="fl.Id + ''" />
        </el-select>
        <el-input v-model="amount" auto-complete="off" style="width:200px;margin-top:10px;margin-left: 10px;"
          placeholder="统一金额"></el-input>
      </div>
      <el-tooltip class="item" effect="light" placement="right">
        <div slot="content"><span style="font-size: 16px;">如果有用户投诉文件有密码等<span
              style="color:#e20101">无法使用的情况</span>，经客服核实后<br />
            会发起全额退款，包括用户下载产生的流量费也<span style="color:#e20101">由该作者承担</span></span></div>
        <div>
          <a href="https://mp.weixin.qq.com/s/NhYs51XBuWYvy9uRDXRBkw" target="_blank">
            <img src="//static.jazpan.com/img/scznx.jpg" style="margin-top: 10px;width: 100%;height: 35px;" />
          </a>
          <div class="xtips">
            小提示：请不要上传有密码等有限制的文件
          </div>
          <div class="xtips">
            <a href="https://jazpan.com/cmt/t/26" target="_blank">Windows App 可以上传超过2G的文件</a>
          </div>
        </div>
      </el-tooltip>
    </div>
    <div>
      <el-upload ref="upload" class="upload-demo" name="upfile" drag multiple :auto-upload="false"
        :action.sync="uploadActUrl" :before-upload="handleBeforeUpload" :on-error="handleError"
        :on-success="handleSuccess">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
        <div class="el-upload__tip" slot="tip"></div>
      </el-upload>
    </div>
    <proEdit ref="proEdit" />
    <ChongVip ref="chongVipDlg" @submitOK="$refs.chongVipDlg.close()" />
  </div>
</template>
<script>
import ChongVip from '@/components/ChongVip'
import proEdit from '@/views/ruis/user/proEdit';
export default {
  components: { ChongVip, proEdit },
  data() {
    return {
      boxids: '',
      amount: '',
      fenlei: '',
      fenleis: [],
      upTokenData: null,

      uploadActUrl: '',

      submiting: false,
    }
  }, props: [
    'boxid'
  ], watch: {
    boxid(val) {
      console.log('upload boxid update:', val);
      this.boxids = val || '';
    }
  }, mounted() {
    console.log('upload boxid:', this.boxids);
    this.getFenleis();
    // this.getToken();
  }, methods: {
    refreshPg() {
      window.top.location.reload();
    },
    /* getToken () {
      this.$post('/up/token').then(res => {
        this.upTokenData = res.data;
        // console.log('upload getToken', this.upTokenData);
      }).catch(err => {
        this.$message({
          message: '获取令牌失败！',
          type: 'error'
        });
      });
    }, */ getFenleis() {
      this.$post('/comm/fls/pro').then(res => {
        console.log('getFenleis:', res);
        this.fenleis = res.data;
      }).catch(err => {
        this.listLoading = false;
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    upSubmit() {
      if (this.fenlei == '') {
        this.$message({
          message: '请先选择分类',
          type: 'error'
        });
        return;
      }

      if (this.submiting) return;
      let istls = false;
      if (window && window.location) {
        const ul = window.location.toString();
        istls = ul.startsWith('https:');
      }
      this.$post('/up/token', { tls: istls }).then(res => {
        this.upTokenData = res.data;
        this.submiting = true;
        this.$refs.upload.submit();
      }).catch(err => {
        /* this.$message({
          message: '获取令牌失败！',
          type: 'error'
        }); */
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
        if (err.response.status == 511) {
          setTimeout(() => this.$refs.chongVipDlg.show(), 1000);
        }
        if (err.response.status == 512) {
          setTimeout(() => this.$refs.proEdit.show(), 1000);
        }
      });
    },
    handleBeforeUpload(file) {
      const flsz = file.size;
      console.log('file [' + file.name + '] size:' + flsz);
      if (flsz < 100) {
        this.$message({
          message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 文件太小了',
          type: 'error'
        });
        return false;
      }
      if (flsz > 2 * 1024 * 1024 * 1024) {
        this.$message({
          message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 超过2G (使用App最大可至4G)',
          type: 'error'
        });
        return false;
      }
      if (!this.upTokenData) {
        this.$message({
          message: '未获取到token,请刷新页面',
          type: 'error'
        });
        return false;
      }
      return new Promise((resolve, reject) => {
        // 拼接上传url
        // 此处动态配置action URL
        // this.upload.newurl = this.upload.url + this.upload.relationid;
        const tms = encodeURIComponent(this.upTokenData.tms);
        let upths = `${this.upTokenData.host}`;
        if (!upths.endsWith('/uploadfile')) {
          upths = `${this.upTokenData.host}/file/uploadfile`;
        }
        this.uploadActUrl = `${upths}?fl1=${this.fenlei}&amount=${this.amount}&boxid=${this.boxids}`
          + `&uid=${this.upTokenData.uid}&tms=${tms}&sign=${this.upTokenData.sign}`;
        // dom上传地址更新完成后，触发上传
        this.$nextTick(() => resolve());

      });
      /* this.uploadActUrl = `${this.upTokenData.host}/file/up?fl1=${this.fenlei}&amount=${this.amount}&boxid=${this.boxids}`
        + `&uid=${this.upTokenData.uid}&tms=${this.upTokenData.tms}&sign=${this.upTokenData.sign}`;
      console.log('uploadActUrl:' + this.uploadActUrl);
      return true; */
    },
    handleError(err) {
      this.submiting = false;
      console.log('handleError', err);
      this.$message({
        message: '上传失败！' + err.message || '',
        type: 'error'
      });
    }, handleSuccess(res) {
      this.submiting = false;
      console.log('handleSuccess', res);
      /*this.$message({
      message: '上传成功',
      type: 'success'
      });*/
      // this.getList();
      this.$emit('okfun');
    }
  }
}
</script>

<style scoped>
.xtips {
  font-size: 12px;
  margin-top: 5px;
  color: #c43d3d;
}

.xtips a {
  color: #c43d3d;
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// Upload.vue?5b1b2ad4